<!-- 地址组件 -->
<template>
  <div class="location">
    <div class="location-content">
        <div class="tab">
            <span class="name" v-for="item in locations" :key="item.locationId">{{item.location}} <i class="close" @click="close(item.locationId)">&times;</i></span>
            <span class="tip">最多可选{{count}}个地址</span>
        </div>
        <div class="tab-content">
            <div class="province">
                <div class="province-box">
                <span @mouseover="cityOver(index)" @mouseout="cityOut(item.id)" class="tag" @click="cityClick($event,1,item.id, item.name, index)" v-for="(item,index) in locationList" :key="item.id">{{item.name}}</span>
                </div>
            </div>
            <div class="city">
              <div v-show="showCity == index" class="city-box" v-for="(i,index) in locationList.length" :key="index">
                <div class="city-con">
                  <span class="onecity tag" @click="onecityClick($event, locationList[index].id, locationList[index].name)" :ref="'c'+locationList[index].id" :data-id="locationList[index].id">{{locationList[index].name}}</span>
                <span :ref="'c'+item.id" class="tag" @click="cityClick($event,2,item.id, item.name)" v-for="item in locationList[index].subLocation" :key="item.id">{{item.name}}</span>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div class="toast-btn">
            <span class="btn-cancel btn" @click="btnCancel">取消</span>
            <span class="btn-submit btn" @click="btnSubmit">确定</span>
        </div>
  </div>
</template>

<script>
import { getAllLocations } from "@/api/common";
export default {
  data() {
    return {

      timer: null,

      locationList: [], // 所有的地区
      province: [], // 省级地区
      city: [], // 市级地区

      showCity: 0,
      locations: this.propsLocation, // 要显示的对象
      count: this.maxCount, // 选择最大数量
      cityChild: -1 // 是否可以点击子成市
    };
  },
  watch: {
    // locationList() {
    //     getAllLocations({}).then(res => {
    //         if (res.success) {
    //             this.locationList = res.data;
    //             localStorage.setItem('Location', JSON.stringify(res.data))
    //         }
    //     })
    // }
  },
  props: {
    propsLocation: {  //传过来的城市
      type: Array,
      default: []
    },
    maxCount: {
      type: Number,
      default: 1
    }
  },
  components: {},

  computed: {},

  created() {
    this.getAllLocationList();
  },

  mounted() {
    this.init();
  },

  methods: {
    btnSubmit() {
            this.$emit('btnSubmit',this.locations)
        },
        btnCancel() {
            this.$emit('btnCancel',{})
        },
    norepeatArr(arr) {
      var result = [],
              hash = {};
            for (var i = 0; i < arr.length; i++) {
              if (!hash[arr[i]]) {
                result.push(arr[i]);
                hash[arr[i]] = true;
              }
            }
            return result;
    },
    init() {
      // 筛选出一级省
      this.locationList.forEach((ele, index) => {
        //console.log(ele.id);
        if (ele.id.length == 2) {
            this.province.push({
              id: ele.id,
              name: ele.name
            });
            this.city.push(ele.subLocation);
          }
        if (this.locations.length > 0) {
          if (ele.id == this.locations[0].locationId.substring(0, 2)) {
            this.showCity = index;
          }
        }
      });
      // 回显城市
      if (this.locations.length > 0 ) {
        this.locations.forEach(item => {
          console.log(item);

          var pid = "c" + item.locationId;

          if (pid.length > 3) {
            this.$refs[pid][0].className = "tag active";
          } else {
            this.$refs[pid][0].className = "tag onecity active";
            this.cityChild = item.locationId;
            this.locationList.forEach(items => {
              if (items.id == item.locationId) {
                for (let i = 1; i < items.subLocation.length + 1; i++) {
                  i = i > 9 ? i : "0" + i;
                  this.$refs[pid + i][0].className = "tag nomouse";
                }
              }
            });
          }
        });
      }
    },
    // 选择省
    onecityClick(e, id, name) {
      
      if (e.target.className.indexOf("active") > -1) {
        this.locationList.forEach(item => {
          if (item.id == id) {
            var pid = "c" + id;
            this.$refs[pid][0].className = "tag onecity";
            this.cityChild = -1;
            this.locations.forEach((item, index) => {
              if (item.location.indexOf(name) > -1) {
                this.locations.splice(index, 1);
              }
            });
            for (let i = 1; i < item.subLocation.length + 1; i++) {
              i = i > 9 ? i : "0" + i;
              this.$refs[pid + i][0].className = "tag";
            }
          }
        });
      } else {
        if (this.locations.length >= this.count) {
          this.$loader({
            showIcon: false,
            tips: `最多选择${this.count}项`,
            duration: 2000
          })
          // alert(`最多选择${this.count}项`);
          return;
        }
        this.locationList.forEach(item => {
          if (item.id == id) {
            var pid = "c" + id;
            this.$refs[pid][0].className = "tag active onecity";
            this.cityChild = id;
            this.locations.push({
              locationId: id,
              location: name
            });

            // var result = this.norepeatArr([1,3,4,5,6,3])
            this.locations.forEach((item, index) => {
              if (item.location.indexOf(name + "-") > -1) {
                this.locations.splice(index, 1);
              }
            });
            this.locations.forEach((item, index) => {
              if (item.location.indexOf(name + "-") > -1) {
                this.locations.splice(index, 1);
              }
            });
            for (let i = 1; i < item.subLocation.length + 1; i++) {
              i = i > 9 ? i : "0" + i;
              this.$refs[pid + i][0].className = "tag nomouse";
            }
          }
        });
      }

      // this.$emit("cityClick", this.locations);
    },
    // 城市点击选择
    cityClick(e, index, id, name, num) {
      if (index == 1) {
        this.showCity = num;
      }
      if (index == 2) {
        if (this.cityChild != id.substring(0, 2)) {
          if (e.target.className.indexOf("active") > -1) {
            e.target.className = "tag";
            if (this.locations.length > 0) {
              this.close(id);
            }
          } else {
            if (this.locations.length >= this.count) {
              // alert(`最多选择${this.count}项`);
              this.$loader({
            showIcon: false,
            tips: `最多选择${this.count}项`,
            duration: 2000
          })
              
              return;
            }
            e.target.className = "tag active";
            var nameOne = "";
            if (id.length == 4) {
              this.province.forEach(item => {
                if (item.id == id.substring(0, 2)) {
                  nameOne = item.name + "-";
                }
              });
            }
            this.locations.push({
              locationId: id,
              location: nameOne + name
            });
          }
          // this.$emit("cityClick", this.locations);
        }
      }
    },
    cityOver(id) {
      
      // if (this.timer) {
      //   clearTimeout(this.timer)
      // }
      // this.timer = setTimeout(() => {
      //   this.showCity = id;
      //   this.timer = null;
      // }, 500);
    },
    cityOut() {},
    // 删除选择项
    close(id) {
      this.locations.forEach((item, index) => {
        if (item.locationId == id) {
          this.locations.splice(index, 1);
        }
      });
      if (id.length == 2) {
        this.locationList.forEach(item => {
          if (item.id == id) {
            var pid = "c" + id;
            this.$refs[pid][0].className = "tag onecity";
            this.cityChild = -1;

            for (let i = 1; i < item.subLocation.length + 1; i++) {
              i = i > 9 ? i : "0" + i;
              this.$refs[pid + i][0].className = "tag";
            }
          }
        });
      } else {
        var pid = "c" + id;
        this.$refs[pid][0].className = "tag";
      }
    },
    // 获取地址信息
    getAllLocationList() {
      if (localStorage.getItem("Location")) {
        this.locationList = JSON.parse(localStorage.getItem("Location"));
      } else {
        getAllLocations({}).then(res => {
          if (res.success) {
            this.locationList = res.data;
            localStorage.setItem("Location", JSON.stringify(res.data));
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.nomouse {
  cursor: not-allowed !important;
}
.nomouse:hover {
  background: #f9f9f9 !important;
  color: #999 !important;
}
.location {
  .tab {
    height: 50px;
    position: relative;
    top: -20px;
    margin: 0 -20px;
    border-bottom: 1px solid #eee;
    line-height: 50px;
    padding: 0 10px;
    .name {
      padding: 5px 12px;
      border-radius: 20px;
      margin-top: 10px;
      background: #f9f9f9;
      cursor: pointer;
      color: #333;
      font-size: 14px;
      margin-left: 4px;
      .close {
        padding-left: 4px;
        color: #999;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #666;
        }
      }
    }
    .tip {
      color: #999999;
      padding-left: 10px;
      position: absolute;
      right: 16px;
    }
  }
  .tab-content {
    margin-top: -20px;
    margin-left: -20px;
    margin-right: -20px;
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #eee;
    .province {
      width: 110px;
      background: #f9f9f9;
      overflow: hidden;
      height: 310px;
      .province-box {
        width: 130px;
        background: #f9f9f9;
        overflow: hidden;
        overflow-y: auto;
        height: 310px;
      }
      .tag {
        display: block;
        padding: 12px 0;
        cursor: pointer;
        padding-left: 20px;
        &:hover {
          color: #3b87ff;
        }
      }
      .tag.active {
        color: #3b87ff;
      }
    }
    .city {
      height: 310px;
      width: 470px;
      padding: 15px 15px 0 15px;
      box-sizing: border-box;
      overflow: hidden;
      .city-con {
        width: 472px;
    overflow-y: scroll;
    height: 286px;
      }
      .tag {
        display: inline-block;
        padding: 5px 10px;
        background: #f9f9f9;
        border-radius: 2px;
        margin: 5px;
        color: #999;
        cursor: pointer;
        &:hover {
          background: #3b87ff;
          color: #fff;
        }
      }
      .onecity {
        display: block;
        width: 46px;
        text-align: center;
        margin-bottom: 10px;
      }
      .tag.active {
        background: #3b87ff;
        color: #fff;
      }
    }
  }
}
.toast-btn {
        position: absolute;
        bottom: 20px;
        right: 20px;
    }
    .toast-btn .btn {
        font-size:16px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
        line-height: 40px;
        width:100px;
        border-radius:2px;
        height:40px;
    }
    .toast-btn .btn-submit {
        color: #fff;
        background:#3B87FF;
        border: 1px solid #3B87FF;
    }
    .toast-btn .btn-cancel {
        color: #333333;
        background:rgba(249,249,249,1);
        border: 1px solid #eee;
        margin-right: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Location/Location.vue